import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { FormStatusEnum } from "app/services/api/types/forms/enums/FormStatusEnums";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { Button, ButtonText } from "ui/gluestack/button";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { useHandleFormSignOff } from "../hooks/useHandleFormSignOff";

interface Props {
  entry: SubmittedFormModel;
}

// Keep in sync with FormTagsEnum::getSignOffPermission() on the backend.
const SIGN_OFF_PERMISSION_BY_TAG: Partial<Record<FormEnums, PermissionsEnums>> =
  {
    [FormEnums.ADMISSION_CHECKLIST]:
      PermissionsEnums.SIGN_OFF_ADMISSION_CHECKLIST_FORM,
    [FormEnums.ACCIDENTS_INCIDENTS]:
      PermissionsEnums.SIGN_OFF_ACCIDENT_INCIDENT_FORM,
  };

export function AssessmentEntrySignOffAction({ entry }: Props) {
  const { handleSignOff, isSignOffLoading } = useHandleFormSignOff({
    form: entry,
  });

  if (entry.status !== FormStatusEnum.PENDING_SIGNOFF) return null;

  const permission = SIGN_OFF_PERMISSION_BY_TAG[entry.form.tag];
  if (!permission) return null;

  return (
    <PermissionCheck permission={permission}>
      <Button
        action="secondary"
        onPress={handleSignOff}
        disabled={isSignOffLoading}
      >
        <ButtonText>Sign off</ButtonText>
      </Button>
    </PermissionCheck>
  );
}
